import { ProductMetaData } from '../ProductMetaData'

export class Others extends ProductMetaData {
}
